<template>
    <img class="w-36" src="@/assets/images/logo.png" alt="">
</template>